class ProjectSdg {
  constructor({ _id, code, title, url }) {
    this.id = _id;
    this.code = code;
    this.title = title;
    this.url = url;
  }
}

export default ProjectSdg;
